<script setup lang="ts">
useHead({
	meta: [
		{ charset: 'utf-8' },
		{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
		{ name: 'mobile-web-app-capable', content: 'yes' },
		{ name: 'apple-mobile-web-app-capable', content: 'yes' },
		{ name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
	],
	link: [
		{ rel: 'icon', href: '/favicon.ico' },
		{ rel: 'apple-touch-icon', href: '/images/apple-touch-icon-180x180.png', sizes: '180x180' },
	],
	htmlAttrs: { lang: 'en', class: 'overflow-x-hidden' },
});

// Segnala che font/icone sono pronti (nasconde il "testo gigante" delle icone prima del load)
function markIconsLoaded() {
	if (import.meta.client) {
		document.documentElement.classList.add('icons-loaded');
	}
}

// Ripristina la sessione all'avvio se c'è un token salvato
onMounted(async () => {
	const route = useRoute();
	const { fetchUser, user } = useAuth();

	// Nascondi icone fino al caricamento del font (Material Symbols); fallback dopo 3s
	if (import.meta.client) {
		Promise.race([
			document.fonts.ready,
			new Promise(resolve => setTimeout(resolve, 3000)),
		]).then(markIconsLoaded);
	}

	// Se l'utente è già caricato, non fare nulla
	if (!user.value) {
		// Verifica se c'è un token nel localStorage
		const token = localStorage.getItem('directus_access_token');

		// Se c'è un token, prova a recuperare i dati dell'utente
		if (token) {
			try {
				const result = await fetchUser();
				if (result.success) {
					console.debug('Sessione ripristinata con successo');
				}
			} catch (error: any) {
				// Se il token non è valido, fetchUser() rimuoverà automaticamente il token
				console.debug('Errore durante il ripristino della sessione:', error.message || error);
			}
		}
	}

	// Se aperto come PWA (da icona home screen) e siamo sulla home, vai all'area riservata
	// (il middleware auth reindirigerà al login se non autenticato)
	if (useIsPwa() && route.path === '/') {
		await navigateTo('/area-riservata');
	}
});
</script>

<template>
	<div class="overflow-x-hidden">
		<VitePwaManifest />
		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>
	</div>
</template>
